import { Link } from "react-router-dom";
import { Mail, Phone, MapPin } from "lucide-react";
import { useSite, phoneDisplay } from "../context/SiteContext";

export default function Footer() {
  const site = useSite();
  return (
    <footer data-testid="site-footer" className="bg-ink text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10 py-14 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-8">
          <div className="md:col-span-4">
            <img src="/logo-full-white.png" alt="Razor Build Limited logo" className="h-16 w-auto mb-5" />
            <p className="font-mono text-[11px] tracking-[0.25em] uppercase text-gold mb-4">Build • Renovate • Maintain</p>
            <p className="text-sm text-white/60 leading-relaxed max-w-xs">
              Licensed Building Practitioner. Residential renovations, alterations, extensions and new builds across the Wellington region.
            </p>
          </div>
          <div className="md:col-span-2">
            <h3 className="font-mono text-[11px] tracking-[0.2em] uppercase text-white/40 mb-4">Services</h3>
            <ul className="space-y-2.5 text-sm">
              <li><Link to="/renovations" data-testid="footer-renovations" className="text-white/75 hover:text-gold transition-colors">Renovations</Link></li>
              <li><Link to="/extensions" data-testid="footer-extensions" className="text-white/75 hover:text-gold transition-colors">Alterations &amp; Extensions</Link></li>
              <li><Link to="/new-builds" data-testid="footer-new-builds" className="text-white/75 hover:text-gold transition-colors">New Builds</Link></li>
              <li><Link to="/contact" data-testid="footer-bathrooms" className="text-white/75 hover:text-gold transition-colors">Bathrooms &amp; Kitchens</Link></li>
              <li><Link to="/contact" data-testid="footer-outdoor" className="text-white/75 hover:text-gold transition-colors">Decks &amp; Outdoor</Link></li>
              <li><Link to="/contact" data-testid="footer-smaller" className="text-white/75 hover:text-gold transition-colors">Repairs &amp; Smaller Jobs</Link></li>
              <li><Link to="/#urgent" data-testid="footer-urgent" className="text-[#FF8A7A] hover:text-[#FF6B5E] transition-colors">Urgent &amp; Emergency Work</Link></li>
            </ul>
          </div>
          <div className="md:col-span-3">
            <h3 className="font-mono text-[11px] tracking-[0.2em] uppercase text-white/40 mb-4">Service Areas</h3>
            <ul className="space-y-2.5 text-sm text-white/75">
              {site.service_areas.map((a) => <li key={a}>{a}</li>)}
            </ul>
          </div>
          <div className="md:col-span-3">
            <h3 className="font-mono text-[11px] tracking-[0.2em] uppercase text-white/40 mb-4">Contact</h3>
            <ul className="space-y-3 text-sm">
              <li>
                <a href={`mailto:${site.email}`} data-testid="footer-email" className="inline-flex items-center gap-2.5 text-white/75 hover:text-gold transition-colors">
                  <Mail className="w-4 h-4 text-gold shrink-0" /> {site.email}
                </a>
              </li>
              <li>
                <a href={`tel:${site.phone}`} data-testid="footer-phone" className="inline-flex items-center gap-2.5 text-white/75 hover:text-gold transition-colors">
                  <Phone className="w-4 h-4 text-gold shrink-0" /> {phoneDisplay(site.phone)}
                </a>
              </li>
              <li className="inline-flex items-center gap-2.5 text-white/75">
                <MapPin className="w-4 h-4 text-gold shrink-0" /> Wellington Region, New Zealand
              </li>
            </ul>
            <Link to="/contact" data-testid="footer-start-project" className="mt-6 inline-block bg-gold hover:bg-golddark transition-colors text-white font-mono text-[11px] tracking-[0.15em] uppercase px-5 py-3">
              Start Your Project
            </Link>
          </div>
        </div>
        <div className="mt-14 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <p className="text-xs text-white/40">Copyright © {new Date().getFullYear()} Razor Build Limited. All rights reserved.</p>
          <div className="flex gap-6 text-xs">
            <Link to="/privacy" data-testid="footer-privacy" className="text-white/40 hover:text-white/80 transition-colors">Privacy Policy</Link>
            <Link to="/terms" data-testid="footer-terms" className="text-white/40 hover:text-white/80 transition-colors">Terms &amp; Conditions</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
